import { queryStbDeviceApps, queryStbDeviceAppLogs } from '@/services/devices';

export default {
  namespace: 'CompanyAppManager_stbDevice',

  state: {
    data: {},
    deviceApps: {
      data: [],
      total: 0,
    },
  },

  effects: {
    *fetchStbDeviceApps({ payload }, { call, put }) {
      const { data } = yield call(queryStbDeviceApps, payload);

      yield put({
        type: 'saveApps',
        payload: data,
      });
    },
    *fetchStbDeviceAppLogs({ payload }, { call, put }) {
      const {
        data: { data, meta },
      } = yield call(queryStbDeviceAppLogs, payload);

      yield put({
        type: 'save',
        payload: {
          list: data,
          pagination: {
            total: meta.total,
            pageSize: meta.per_page,
            current: meta.current_page,
          },
        },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
    saveApps(state, { payload }) {
      return {
        ...state,
        deviceApps: payload,
      };
    },
  },
};
